import React, { useEffect, createElement } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function SEOHead({
  page
}: {
  page: 'home' | 'specialists' | 'companies';
}) {
  const {
    t,
    language
  } = useLanguage();
  useEffect(() => {
    // Set document title
    const seoTitle = t(`seo.${page}.title`);
    if (typeof seoTitle === 'string') {
      document.title = seoTitle;
    }
    // Set meta description
    const seoDesc = t(`seo.${page}.description`);
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    if (typeof seoDesc === 'string') {
      metaDesc.content = seoDesc;
    }
    // Set canonical URL
    const baseUrl = 'https://elvora.consulting';
    const pagePath = page === 'home' ? '/' : `/${page}`;
    const canonicalUrl = `${baseUrl}/${language}${pagePath}`;
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
    // Set hreflang tags
    const languages = ['en', 'ru', 'ua', 'ka'];
    // Remove existing hreflang links
    document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
    languages.forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang === 'ua' ? 'uk' : lang; // ua → uk for proper ISO code
      link.href = `${baseUrl}/${lang}${pagePath}`;
      document.head.appendChild(link);
    });
    // x-default hreflang
    const xDefault = document.createElement('link');
    xDefault.rel = 'alternate';
    xDefault.hreflang = 'x-default';
    xDefault.href = `${baseUrl}/en${pagePath}`;
    document.head.appendChild(xDefault);
    return () => {
      // Cleanup hreflang on unmount
      document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
    };
  }, [language, page, t]);
  return null;
}